var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.pageLoaded ? [_c('Header', {
    attrs: {
      "hasHeaderLine": _vm.hasHeaderLine
    }
  }), _c('currencies'), _vm.category ? [_vm.articles.desktop ? _c('div', {
    staticClass: "container pc"
  }, [_vm._l(_vm.currentPage * 3, function (n) {
    return [_vm.articles.desktop[n] ? [_vm.articles.desktop[n] ? _c('cards-section', {
      key: 'journal-rows_' + n,
      attrs: {
        "code": _vm.category,
        "items": _vm.articles.desktop[n]
      }
    }) : _vm._e()] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "container phone"
  }, [_vm._l(_vm.currentPage * 4, function (n) {
    return [_vm.articles.mobile[n] ? [_vm.articles.mobile[n] ? _c('div', {
      key: 'extra-mobile-card' + n
    }, [_vm.articles.mobile[n] ? _c('ArticleCardMobile', {
      attrs: {
        "article": _vm.articles.mobile[n]
      }
    }) : _vm._e()], 1) : _vm._e()] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()], 2)] : _vm._e(), _c('SocialBanner'), _c('Footer')] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }